export enum PatientRecordStatus {
	Undefined,
	InProgress,
	Arrived,
	Discontinued,
	Scheduled,
	RequestedSigned,
	Requested,
	ExamDone,
	Dictated,
	Transcribed,
	NRR,
	Signed1,
	Signed2,
	Signed3,
	Approved,
	Canceled
}
